import store from '@/store/index.js'
import { APIService } from '@/api/APIService.js'

async function handleApiCall (call, mutation, action, data) {
  const apiService = new APIService()
  try {
    let result = {}
    if (data) {
      result = await apiService[call](data)
    } else {
      result = await apiService[call]()
    }
    if (result.status === 200 && result.data) {
      if (call === 'refreshDossier') {
        store.dispatch(action, result.data)
        return
      }
      if (call === 'login' || call === 'internalLogin') {
        store.commit(mutation, result.data)
        if (result.data.Dossier) {
          store.dispatch(action, result.data.Dossier)
        }
        return result.data
      }
      if (call === 'getClaim' || call === 'refreshClaim') {
        store.commit(mutation, result.data)
        return
      }
      // generic call
      if (mutation) {
        store.commit(mutation, result.data)
      }
      return result.data
    }
  } catch (error) {
    if (call === 'login' || call === 'updateLogin' || call === 'log/exception') {
      return error.response
    }
    if (call.includes('download')) {
      const result = await store.dispatch(action, {}, { root: true })
      if (!result.loggedin) {
        logout()
      }
    }
    if (error.response.status === 401 || error.response.status === 403) {
      // Unauthorized or forbidden: the session has expired so we have to create a new session via a login
      logout()
    }
    return error.response
  }

  async function logout () {
    await store.dispatch('logout', {}, { root: true })
    window.location.replace(window.location.origin + '/login')
  }
}

export { handleApiCall }
